"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPostgresQueryParams = exports.createTAccountsSumQueryParams = exports.createPrincipalBalancePointInTimeQueryParams = exports.createPrincipalBalanceDailyAverageQueryParams = exports.createOrgProvidedInputParams = void 0;
const common_1 = require("@finley-technologies/common");
const assetVerificationQueryParams_1 = require("./assetVerificationQueryParams");
const orgProvidedInputParams_1 = require("./orgProvidedInputParams");
Object.defineProperty(exports, "createOrgProvidedInputParams", { enumerable: true, get: function () { return orgProvidedInputParams_1.createOrgProvidedInputParams; } });
const principalBalanceDailyAverageQueryParams_1 = require("./principalBalanceDailyAverageQueryParams");
Object.defineProperty(exports, "createPrincipalBalanceDailyAverageQueryParams", { enumerable: true, get: function () { return principalBalanceDailyAverageQueryParams_1.createPrincipalBalanceDailyAverageQueryParams; } });
const principalBalancePointInTimeQueryParams_1 = require("./principalBalancePointInTimeQueryParams");
Object.defineProperty(exports, "createPrincipalBalancePointInTimeQueryParams", { enumerable: true, get: function () { return principalBalancePointInTimeQueryParams_1.createPrincipalBalancePointInTimeQueryParams; } });
const tAccountsSumQueryParams_1 = require("./tAccountsSumQueryParams");
Object.defineProperty(exports, "createTAccountsSumQueryParams", { enumerable: true, get: function () { return tAccountsSumQueryParams_1.createTAccountsSumQueryParams; } });
const createPostgresQueryParams = (params) => {
    const { postgresQuery } = params;
    const { type } = postgresQuery;
    switch (type) {
        case 'assetVerification':
            return (0, assetVerificationQueryParams_1.createAssetVerificationQueryParams)({ postgresQuery });
        case 'orgProvidedInput':
            return (0, orgProvidedInputParams_1.createOrgProvidedInputParams)({ postgresQuery });
        case 'principalBalanceDailyAverage':
            return (0, principalBalanceDailyAverageQueryParams_1.createPrincipalBalanceDailyAverageQueryParams)({
                postgresQuery,
            });
        case 'principalBalancePointInTime':
            return (0, principalBalancePointInTimeQueryParams_1.createPrincipalBalancePointInTimeQueryParams)({
                postgresQuery,
            });
        case 'tAccountsSum':
            return (0, tAccountsSumQueryParams_1.createTAccountsSumQueryParams)({ postgresQuery });
        default:
            return (0, common_1.finleyAssertUnreachable)(type);
    }
};
exports.createPostgresQueryParams = createPostgresQueryParams;
//# sourceMappingURL=index.js.map